import * as Yup from 'yup'

const ChangePasswordSchema = Yup.object().shape({
    newPassword: Yup.string()
        .required('Required')
        .matches(
            /^(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
            'Must contain at least 8 characters, including one uppercase letter and one special character.'
        ),
    confirmNewPassword: Yup.string()
        .oneOf(
            [Yup.ref('newPassword')],
            'New Password and Confirm Password must match'
        )
        .required('Required'),
    password: Yup.string().required('Required'),
})

const ChangePasswordAdminSchema = Yup.object().shape({
    newPassword: Yup.string()
        .required('Required')
        .matches(
            /^(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
            'Must contain at least 8 characters, including one uppercase letter and one special character.'
        ),
    confirmNewPassword: Yup.string()
        .oneOf(
            [Yup.ref('newPassword')],
            'New Password and Confirm Password must match'
        )
        .required('Required'),
})

export { ChangePasswordSchema, ChangePasswordAdminSchema }
